/**
 * Static webpack imports for FleetLocate login assets (fm/spireon/SpireonNew).
 * Avoids runtime layout/provider resolution issues on first load.
 */
const normalizeAsset = (asset) => {
  if (!asset) {
    return '';
  }
  if (typeof asset === 'string') {
    return asset;
  }
  return asset.default || '';
};

const FLEET_LOCATE_ASSETS = {
  'fleetlocate-login-logo.png': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/fleetlocate-login-logo.png')
  ),
  'fleetlocate-app-store.png': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/fleetlocate-app-store.png')
  ),
  'fleetlocate-google-play.png': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/fleetlocate-google-play.png')
  ),
  'FleetLocate_LoginBanners.jpg': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/FleetLocate_LoginBanners.jpg')
  ),
  'FleetLocate_LoginBanners_1.jpg': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/FleetLocate_LoginBanners_1.jpg')
  ),
  'FleetLocate_LoginBanners_Flex2.jpg': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/FleetLocate_LoginBanners_Flex2.jpg')
  ),
  'FleetLocate_LoginBanners_FlexBatteryTracker.jpg': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/FleetLocate_LoginBanners_FlexBatteryTracker.jpg')
  ),
  'FleetLocate_LoginBanners_CamCoach.jpg': normalizeAsset(
    require('globalassets/media/fm/spireon/SpireonNew/FleetLocate_LoginBanners_CamCoach.jpg')
  ),
};

export const getFleetLocateMediaPath = (filename) => FLEET_LOCATE_ASSETS[filename] || '';
